import { useGlobalErrorHandler } from '@/hooks/useGlobalErrorHandler';

/**
 * GlobalErrorHandler component
 *
 * This component subscribes to global API error events and displays
 * toast notifications. It must be rendered inside ToastProvider.
 *
 * Auth errors (401/403) are suppressed as they are handled separately
 * by the authentication system.
 *
 * Queries/mutations can opt-out of global error handling by setting
 * `meta: { skipGlobalErrorHandler: true }` in their options.
 *
 * @example
 * ```tsx
 * // In main.tsx
 * <QueryClientProvider client={queryClient}>
 *   <ToastProvider>
 *     <GlobalErrorHandler />
 *     <RouterProvider router={router} />
 *   </ToastProvider>
 * </QueryClientProvider>
 *
 * // To opt-out of global error handling in a query:
 * useQuery({
 *   queryKey: ['my-query'],
 *   queryFn: fetchData,
 *   meta: { skipGlobalErrorHandler: true },
 * });
 * ```
 */
export function GlobalErrorHandler() {
  // This hook subscribes to global error events and shows toasts
  useGlobalErrorHandler();

  // This component doesn't render anything
  return null;
}
